import { render } from "./DialogAdvertenciaCorreo.vue?vue&type=template&id=73cb2b5a"
import script from "./DialogAdvertenciaCorreo.vue?vue&type=script&lang=js"
export * from "./DialogAdvertenciaCorreo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__